export default __webpack_public_path__ + "static/media/gamefi_03_1.0f76518b.png";